const boxShadows = {
    standard: ['#eaedf5', 0, 3, 10]
};
export default boxShadows;
//# sourceMappingURL=boxShadows.js.map